import { GET_EVENT_ID } from './actions'
const INITIAL_STATE = {
  getEventIdData: [],
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_EVENT_ID:
      return {
        ...state,
        getEventIdData: action?.payload,
      }

    default:
      return state
  }
}
